import React from 'react';
const IconActionCalendar = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18.9999 19H4.99991V8H18.9999V19ZM12.0001 10H7.00009V15H12.0001V10Z" fill="#666666"/>
</svg>
);
};
export default IconActionCalendar;